export default [
  {
    label: 'CPF',
    value: 'cpf',
  },
  {
    label: 'CNPJ',
    value: 'cnpj',
  },
];



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-quote/features/freight-quote/components/sc-additional-information/enums/EnumFederalTaxpayerType.js